export const setCategories = ({ categories }) => (state /* , actions */) => {
  // const category = categories.find(
  //   category => (category.id = state.category.id),
  // );

  // category &&
  //   Promise.resolve({ categoryID: category.id }).then(actions.setCategory);

  return {
    ...state,
    categories: categories || [],
    loadingCategories: false,
  };
};
